import type { VsmContext, PageConfigEntry, PageConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { SearchBoxPageConfig } from '../types'
import { name } from '../symbols'

const searchBoxPageConfig: PageConfigFn<SearchBoxPageConfig> = ({ api }: VsmContext) => {
	const isMobileView = api.env.isMobileView()
	const searchBoxComponents = api.components.getComponentsByType('SearchBox')
	const searchBoxIds = Object.keys(searchBoxComponents)

	if (!isMobileView || searchBoxIds.length === 0) {
		return { shouldLoadPageFeature: false }
	}

	const ancestors = api.components.getAncestors()
	const parentMenuContainerById: Record<string, string> = {}

	for (const compId of searchBoxIds) {
		const compAncestors = ancestors[compId] ?? []
		for (const ancestorId of compAncestors) {
			if (api.components.getCompType(ancestorId) === 'MenuContainer') {
				parentMenuContainerById[compId] = ancestorId
				break
			}
		}
	}

	return {
		shouldLoadPageFeature: true,
		pageConfig: { parentMenuContainerById },
	}
}

export const pageConfig: PageConfigEntry<SearchBoxPageConfig> = {
	name,
	configFactory: searchBoxPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
